import styled from 'styled-components';
import ds from 'designsystem';

const DebugOptionWrapper = styled.div`
  height: 100%;
  padding: ${ds.get('metrics.xs')} 0 ${ds.get('metrics.xs')} ${ds.get('metrics.xs')};
  background-color: ${ds.brand('white')};
  border-left: 2px solid ${ds.brand('background')};
  flex-grow: 1;
`;

export default DebugOptionWrapper;



// WEBPACK FOOTER //
// ./src/blocks/DebugComponents/DebugBar/DebugOption/DebugOptionWrapper.jsx